 @if(!templateForPermitForm){
<button
  class="btn btn-raised btn-primary"
  type="button"
  (click)="launchChildSummary()"
>
  Open Summary
</button>
}
 @else{
  @if(showSummary === false){
    <wm-common-button
    [data]="{
      text: 'View Summary' ,
      variant: 'flat',
      className: 'button-radius-4 w-80',
      onClick:launchJanusChildSummary.bind(this)
    }"
  ></wm-common-button>
  }@else{
    <wm-application-summary [appId]="callActivity.model.callingWorkflowApplicationId" [renderPrintMode]="true" [bgWhite]="summaryViewBGJanus" [showPrint]="false" [editApplicationJanusView]="editApplicationJanusView" [allowReopenChildInspectionApplicationsParentActivityId]="allowReopenChildInspectionApplicationsParentActivityId" ></wm-application-summary>
  }

 }
